import { LineOfBusiness } from '@breathelife/types';
import ApiService from './ApiService';

export async function fetchAllLinesOfBusiness(): Promise<LineOfBusiness[]> {
  const response = await ApiService.admin.fetchAllLinesOfBusiness();
  return response.data;
}
